import React, { FC, useState } from 'react';
import { useGetProgramMasterData } from 'src/api/mutations/useGetProgramMasterData';
import { isFemaleProfile } from 'src/utils/genderUtils';
import './IncreaseStrengthSteps.scss'; // Reusing the same SCSS for consistency
import RehabilitationMaleAnklesIcon from 'url:src/assets/images/trainer/program-generator/rehabilitation-male-ankles.webp';
// import RehabilitationMaleCoreIcon from 'url:src/assets/images/trainer/program-generator/rehabilitation-male-core.webp';
// import RehabilitationMaleElbowIcon from 'url:src/assets/images/trainer/program-generator/rehabilitation-male-elbow.webp';
import RehabilitationMaleFullBodyIcon from 'url:src/assets/images/trainer/program-generator/rehabilitation-male-full-body.webp';
import RehabilitationMaleHamstringsIcon from 'url:src/assets/images/trainer/program-generator/rehabilitation-male-hamstrings.webp';
import RehabilitationMaleHipsIcon from 'url:src/assets/images/trainer/program-generator/rehabilitation-male-hips.webp';
import RehabilitationMaleKneesIcon from 'url:src/assets/images/trainer/program-generator/rehabilitation-male-knees.webp';
import RehabilitationMaleNeckIcon from 'url:src/assets/images/trainer/program-generator/rehabilitation-male-neck.webp';
import RehabilitationMaleShouldersIcon from 'url:src/assets/images/trainer/program-generator/rehabilitation-male-shoulders.webp';
import RehabilitationMaleSpineBackIcon from 'url:src/assets/images/trainer/program-generator/rehabilitation-male-spine-back.webp';
import RehabilitationMaleWristsIcon from 'url:src/assets/images/trainer/program-generator/rehabilitation-male-wrists.webp';
import RehabilitationFemaleAnklesIcon from 'url:src/assets/images/trainer/program-generator/rehabilitation-female-ankles.webp';
// import RehabilitationFemaleCoreIcon from 'url:src/assets/images/trainer/program-generator/rehabilitation-female-core.webp';
// import RehabilitationFemaleElbowIcon from 'url:src/assets/images/trainer/program-generator/rehabilitation-female-elbow.webp';
import RehabilitationFemaleFullBodyIcon from 'url:src/assets/images/trainer/program-generator/rehabilitation-female-full-body.webp';
import RehabilitationFemaleHamstringsIcon from 'url:src/assets/images/trainer/program-generator/rehabilitation-female-hamstrings.webp';
import RehabilitationFemaleHipsIcon from 'url:src/assets/images/trainer/program-generator/rehabilitation-female-hips.webp';
import RehabilitationFemaleKneesIcon from 'url:src/assets/images/trainer/program-generator/rehabilitation-female-knees.webp';
import RehabilitationFemaleNeckIcon from 'url:src/assets/images/trainer/program-generator/rehabilitation-female-neck.webp';
import RehabilitationFemaleShouldersIcon from 'url:src/assets/images/trainer/program-generator/rehabilitation-female-shoulders.webp';
import RehabilitationFemaleSpineBackIcon from 'url:src/assets/images/trainer/program-generator/rehabilitation-female-spine-back.webp';
import RehabilitationFemaleWristsIcon from 'url:src/assets/images/trainer/program-generator/rehabilitation-female-wrists.webp';

interface MobilityStep1Props {
  value?: string[];
  clientBodyProfile?: string;
  onChange?: (value: string[]) => void;
}

// Which mobility areas should this program focus on?
export const MobilityStep1: FC<MobilityStep1Props> = ({
  value = [],
  clientBodyProfile = 'male',
  onChange,
}) => {
  // const genderKey = clientBodyProfile.toLowerCase() as 'male' | 'female';
  const [selectedArea, setSelectedArea] = useState<string[]>(value);
  const { data: programMasterData, isLoading, isError } = useGetProgramMasterData();

  const isFemale = isFemaleProfile(clientBodyProfile);
  const iconMap: Record<string, React.ReactNode> = {
    full_body: isFemale ? (
      <img
        src={RehabilitationFemaleFullBodyIcon}
        alt="RehabilitationFemaleFullBodyIcon"
        className="program-svg-icon"
      />
    ) : (
      <img
        src={RehabilitationMaleFullBodyIcon}
        alt="RehabilitationMaleFullBodyIcon"
        className="program-svg-icon"
      />
    ),
    shoulders: isFemale ? (
      <img
        src={RehabilitationFemaleShouldersIcon}
        alt="RehabilitationFemaleShouldersIcon"
        className="program-svg-icon"
      />
    ) : (
      <img
        src={RehabilitationMaleShouldersIcon}
        alt="RehabilitationMaleShouldersIcon"
        className="program-svg-icon"
      />
    ),
    hips: isFemale ? (
      <img
        src={RehabilitationFemaleHipsIcon}
        alt="RehabilitationFemaleHipsIcon"
        className="program-svg-icon"
      />
    ) : (
      <img
        src={RehabilitationMaleHipsIcon}
        alt="RehabilitationMaleHipsIcon"
        className="program-svg-icon"
      />
    ),
    knees: isFemale ? (
      <img
        src={RehabilitationFemaleKneesIcon}
        alt="RehabilitationFemaleKneesIcon"
        className="program-svg-icon"
      />
    ) : (
      <img
        src={RehabilitationMaleKneesIcon}
        alt="RehabilitationMaleKneesIcon"
        className="program-svg-icon"
      />
    ),
    ankles: isFemale ? (
      <img
        src={RehabilitationFemaleAnklesIcon}
        alt="RehabilitationFemaleAnklesIcon"
        className="program-svg-icon"
      />
    ) : (
      <img
        src={RehabilitationMaleAnklesIcon}
        alt="RehabilitationMaleAnklesIcon"
        className="program-svg-icon"
      />
    ),
    spine_back: isFemale ? (
      <img
        src={RehabilitationFemaleSpineBackIcon}
        alt="RehabilitationFemaleSpineBackIcon"
        className="program-svg-icon"
      />
    ) : (
      <img
        src={RehabilitationMaleSpineBackIcon}
        alt="RehabilitationMaleSpineBackIcon"
        className="program-svg-icon"
      />
    ),
    hamstrings: isFemale ? (
      <img
        src={RehabilitationFemaleHamstringsIcon}
        alt="RehabilitationFemaleHamstringsIcon"
        className="program-svg-icon"
      />
    ) : (
      <img
        src={RehabilitationMaleHamstringsIcon}
        alt="RehabilitationMaleHamstringsIcon"
        className="program-svg-icon"
      />
    ),
    wrists: isFemale ? (
      <img
        src={RehabilitationFemaleWristsIcon}
        alt="RehabilitationFemaleWristsIcon"
        className="program-svg-icon"
      />
    ) : (
      <img
        src={RehabilitationMaleWristsIcon}
        alt="RehabilitationMaleWristsIcon"
        className="program-svg-icon"
      />
    ),
    neck: isFemale ? (
      <img
        src={RehabilitationFemaleNeckIcon}
        alt="RehabilitationFemaleNeckIcon"
        className="program-svg-icon"
      />
    ) : (
      <img
        src={RehabilitationMaleNeckIcon}
        alt="RehabilitationMaleNeckIcon"
        className="program-svg-icon"
      />
    ),
  };

  const groupData = programMasterData?.trainingGoalDetails?.groups?.find(
    (g: any) => g.goalId === 'mobility',
  );

  const areas = groupData?.options
    ? [...groupData.options].sort((a: any, b: any) => a.order - b.order)
    : [];

  if (isLoading) {
    return <div className="increase-strength-step">{'Loading options...'}</div>;
  }

  if (isError || !groupData) {
    return <div className="increase-strength-step">{'Error loading options.'}</div>;
  }

  return (
    <div className="increase-strength-step">
      <h2 className="step-title">{groupData?.title}</h2>
      <div className="goal-cards-grid">
        {areas.map((area: any) => (
          <div
            key={area.id}
            className={`goal-card ${selectedArea.includes(area.slug) ? 'selected' : ''}`}
            onClick={() => {
              let nextValue = [...selectedArea];
              if (nextValue.includes(area.slug)) {
                nextValue = nextValue.filter((p) => p !== area.slug);
              } else {
                nextValue.push(area.slug);
              }
              setSelectedArea(nextValue);
              if (onChange) onChange(nextValue);
            }}
          >
            <div className="goal-image">{iconMap[area.id]}</div>
            <span className="goal-label">{area.title}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
